import React from 'react';
import { Icon } from './Icon.js';
export const IconLayoutHeaderFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M14.25,16H3.75c-1.517,0-2.75-1.234-2.75-2.75V5.396h1.5v7.854c0,.689,.561,1.25,1.25,1.25H14.25c.689,0,1.25-.561,1.25-1.25V5.396h1.5v7.854c0,1.516-1.233,2.75-2.75,2.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "1", y: "2", width: "16", height: "6", rx: "2.75", ry: "2.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconLayoutHeaderFill18.js.map